

























import { getReservationCategoryList } from '@/api/reservationCategory';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getPopupList } from '@/api/popup';
import Cookies from 'js-cookie';
import Popup from './Popup.vue';

@Component({
  name: 'ReservationCategoryList',
  components: {
    Popup,
  },
})

export default class extends Vue {
  mounted() {
    this.getReservationCategoryList();
    this.getPopupList();
  }

  private categoryList: any[] = [];

  private loading = true;

  private listQuery = {
    facilityName: '',
    typeUid: '1',
  }

  private getReservationCategoryList() {
    this.loading = true;
    getReservationCategoryList(this.listQuery).then((res) => {
      this.categoryList = res.data;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  private goFacilityList(uid: string) {
    this.$router.push({ name: 'FacilityList' });
  }

  private handleClickCategory(uid: string) {
    this.$router.push({ name: 'FacilityList', params: { categoryUid: uid } });
  }

  private popupList: any[] = [];

  private getPopupList() {
    getPopupList().then((res) => {
      this.popupList = res.data;
      this.popupList = this.popupList.map((e: any) => {
        if (Cookies.get(e.uid) !== undefined) return { ...e, display: 'none' };
        return { ...e, display: 'block' };
      });
    });
  }

  private closePopup(item: any, visible: boolean) {
    if (visible) Cookies.set(item.uid, true, { expires: 1 });
    const index = this.popupList.findIndex((d: any) => d.uid === item.uid);
    if (index !== -1) this.popupList[index].display = 'none';
  }
}
